import { styled } from '@mui/material/styles'
import MuiAccordion, { accordionClasses } from '@mui/material/Accordion'

const StyledAccordion = styled(MuiAccordion)({
  '::before': { display: 'none' },

  [`&.${accordionClasses.expanded}`]: { margin: 'auto' },
})

const Accordion = StyledAccordion

export default Accordion
